import React from 'react';
import {HeaderBar} from "../layout/HeaderBar";

interface StandardLayoutProps {
  headerTitle: string;
  headerActionLabel?: string;
  headerActionOnClick?: () => void;
  headerActionIcon?: string;
  body: React.ReactNode;
}

export const StandardLayout = ({
  headerTitle,
  headerActionLabel,
  headerActionOnClick,
  headerActionIcon,
  body,
}: StandardLayoutProps) => (
  <React.Fragment>
    <HeaderBar
      title={headerTitle}
      actionButtonLabel={headerActionLabel}
      actionButtonOnClick={headerActionOnClick}
      actionButtonIcon={headerActionIcon}
    />
    <div className="bg-gray-100 p-6 overflow-y-scroll h-[calc(100%-73px)]">
      {body}
    </div>
  </React.Fragment>
)
